import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from '../../../utils/apiPath';
import { agent } from "../../../utils/agent";

export const loadAboutUsData = createAsyncThunk(
    "aboutUs/loadAboutUsData",
    async (slug, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.CMS_PAGE + slug);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to load home page data');
        }
    }
);

export const loadLeaderData = createAsyncThunk(
    "aboutUs/loadLeaderData",
    async (limit, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.LEADER_DATA, { params: { limit } });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to load leader data');
        }
    }
);

export const loadAdvisorsData = createAsyncThunk(
    'aboutUs/loadAdvisorsData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.ABOUTUS_DATA + "/Advisor");
            return response?.data?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to load advisors data');
        }
    }
);

export const loadTeamsData = createAsyncThunk(
    'aboutUs/loadTeamsData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await agent.get(API.ABOUTUS_DATA + "/Team");
            return response?.data?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to load teams data');
        }
    }
);

const aboutUsSlice = createSlice({
    name: "aboutUs",
    initialState: {
        aboutUsData: null,
        leaders: [],
        teams: [],
        advisors: [],
    },
    reducers: {
        // Synchronous actions
        clearErrors: (state) => {
            state.error = {
                aboutUsData: null,
                leaders: null,
                advisors: null,
                teams: null,
            };
        },
        resetAboutUsData: (state) => {
            state.aboutUsData = null;
            state.leaders = [];
            state.advisors = [];
            state.teams = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadAboutUsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadAboutUsData.fulfilled, (state, action) => {
                state.loading = false;
                state.aboutUsData = action.payload || {};
            })
            .addCase(loadAboutUsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(loadLeaderData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadLeaderData.fulfilled, (state, action) => {
                state.loading = false;
                state.leaders = action.payload || [];
            })
            .addCase(loadLeaderData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(loadAdvisorsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadAdvisorsData.fulfilled, (state, action) => {
                state.loading = false;
                state.advisors = action.payload || [];
            })
            .addCase(loadAdvisorsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(loadTeamsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadTeamsData.fulfilled, (state, action) => {
                state.loading = false;
                state.teams = action.payload || [];
            })
            .addCase(loadTeamsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default aboutUsSlice.reducer;
